<template>
  <teleport to="body">
    <Transition name="fade">
      <div
        v-if="state.open"
        class="fixed inset-0 z-[70] flex items-center justify-center"
        aria-modal="true"
        role="dialog"
      >
        <div
          class="absolute inset-0 bg-black/40 backdrop-blur-sm"
          @click="cancel"
        ></div>
        <div
          class="relative mx-4 w-full max-w-md rounded-2xl bg-white shadow-xl border"
        >
          <div class="p-5">
            <h3 class="text-lg font-semibold mb-2">
              {{ state.title || "Підтвердження" }}
            </h3>
            <p class="text-sm text-gray-700 whitespace-pre-line">
              {{ state.message }}
            </p>
            <div class="mt-5 flex gap-2 justify-end">
              <button
                class="px-4 py-2 rounded-xl border hover:bg-gray-50"
                @click="cancel"
              >
                {{ state.cancelText || "Скасувати" }}
              </button>
              <button
                class="px-4 py-2 rounded-xl bg-pink-200 text-black hover:bg-pink-200/80"
                @click="approve"
              >
                {{ state.confirmText || "Підтвердити" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </teleport>
</template>

<script setup>
import { useConfirm } from "~/composables/useConfirm";
const { state, approve, cancel } = useConfirm();
</script>

<style scoped>
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.16s ease;
}
</style>
